/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Auth from "../shared/Auth";
import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { toast } from 'react-toastify';

class ConservativeCareLog extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {},
            list: [],
            productList: []
        };

        this.load = this.load.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.load();
        qreq.post('/api/product/list?isConservativeCare=true', {}, j => {
            if (j.list)
                this.setState({ productList: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    componentDidUpdate(prevProps) {
        if (this.props.orderID !== prevProps.orderID
            || this.props.allowSubmitting !== prevProps.allowSubmitting)
            this.load();
    }

    load() {
        qreq.get('/api/conservative-care/list?orderID=' + this.props.orderID + (this.props.visitID ? '&visitID=' + this.props.visitID : ''), j => {
            if (j.list)
                this.setState({ list: j.list, loaded: true });
            else
                this.setState({ error: j.errorMessage, loaded: true });
        }, () => {
            this.setState({ error: 'Unknown error. Please try again.', loaded: true });
        });
    }

    submit(e) {
        if (e) e.preventDefault();
        this.setState({ submitting: true });
        var data = { ...this.state.item };
        data.orderID = this.props.orderID;
        if (this.props.visitID)
            data.visitID = this.props.visitID;
        if (data.productID)
            data.productID = Number(data.productID);
        qreq.post('/api/conservative-care/submit', data, j => {
            if (j.errorCode === 0) {
                this.setState({ item: {}, submitting: false });
                this.load();
                toast.success('Submitted conservative care log!');
            }
            else {
                toast.error(j.errorMessage);
                this.setState({ submitting: false });
            }
        }, () => {
            toast.error('Unknown error. Please try again.');
            this.setState({ submitting: false });
        })
    }

    render() {
        if (!this.state.loaded)
            return <LoadingAlert />
        return <Card title="Conservative Care" className="ConservativeCareLog container-fluid">
            {this.state.error ? <Alert type="danger">{this.state.error}</Alert> : <>


                {Auth.hasRole('field') ? this.props.allowSubmitting ? <form onSubmit={this.submit} className="mb-3">
                    <FormInput model={this.state.item} name="content" type="textarea" label="Write notes here..." labelAsPlaceholder disabled={this.state.submitting} />
                    <FormInput model={this.state.item} name="productID" type="select" label="Product Applied" options={this.state.productList} disabled={this.state.submitting} onChange={() => this.setState({ item: { ...this.state.item } }) } />
                    <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-lg btn-primary" disabled={this.state.submitting}><L>Submit</L></button>
                    </div>
                </form> : <Alert><L>Conservative care is disabled on this order. No new logs can be added.</L></Alert>: ''}


                {this.state.list.length === 0 ? <Alert><L>There are no conservative care logs.</L></Alert> : <>

                    {this.state.list.map(i => <div key={i.id} className="d-block rounded data-link drop-shadow p-3 mt-2">
                        <p><L>Posted on</L><i>{Globals.toMDYHMLocalDateString(i.createdDate)}</i><L>by</L><strong>{i.userFullName}</strong><L>.</L></p>
                        {i.visitID !== 0 ? <p><L>On</L><i>{i.visitType}</i> visit scheduled on: {Globals.toMDYHMLocalDateString(i.visitDate)}</p> : ''}
                        {i.productID !== 0 ? <p>Product applied: <b>{i.productName}</b></p> : ''}
                        <p>{i.content}</p>
                    </div>)}
                </>}
            </>}
        </Card>;
    }
}

export default withParamsAndNavigate(ConservativeCareLog);